import React, {useEffect, useRef} from "react"
import PropTypes from "prop-types";
import Tr from "translations/Translations";
import GeneralInfoEntry from "../../panels/generalInfo/components/GeneralInfoEntry";
import OfferInput from "./inputs/OfferInput";
import {TotalPriceTypeGrossFieldVisible, TotalPriceTypeNetFieldVisible} from "constants/PriceTypes";
import Typography from "components/Typography";
import GridBlock from "components/GridBlock";
import BoldTypography from "components/BoldTypography";
import {makeStyles} from "@material-ui/core/styles";
import TextInput from "components/TextInput";
import INPUT_TYPE from "constants/INPUT_TYPE";
import {OfferMode} from "../constants/OfferMode";

const useStyle = makeStyles(theme => ({
    root: {},
    sum: {
        marginTop: theme.spacing(2),
    },
    sumElem: {
        margin: theme.spacing(1, 2, 1, 0)
    }
}))


function OfferPositionItems(
    {
        formikProps,
        itemOffers,
        priceType,
        disabled,
        mode
    }) {

    const classes = useStyle();
    //const [sum, setSum] = useState({net: 0, gross: 0});
    const semaphore = useRef(false);
    const showOptionSumValues = itemOffers.filter(i => !!i.criterium.baseItemId).length > 0;

    useEffect(() => {
        if (semaphore.current) {
            const totalValues = {
                positionOfferValue: null,
                positionOfferGrossValue: null,
                positionOptionOfferValue: null,
                positionOptionOfferGrossValue: null,
                positionTotalOfferValue: null,
                positionTotalOfferGrossValue: null
            };
            const newSum = formikProps.values.itemOffers.filter(i => !i.criterium.baseItemId).reduce((prev, crit) => {
                if (crit.totalNet !== null)
                    prev.net += parseFloat(crit.totalNet);
                if (crit.totalGross !== null)
                    prev.gross += parseFloat(crit.totalGross);
                return prev;
            }, {net: 0, gross: 0});
            totalValues.positionOfferValue = newSum.net;
            totalValues.positionOfferGrossValue = newSum.gross;

            if (showOptionSumValues) {
                const newOptionSum = formikProps.values.itemOffers.filter(i => !!i.criterium.baseItemId).reduce((prev, crit) => {
                    if (crit.totalNet !== null)
                        prev.net += parseFloat(crit.totalNet);
                    if (crit.totalGross !== null)
                        prev.gross += parseFloat(crit.totalGross);
                    return prev;
                }, {net: 0, gross: 0});
                totalValues.positionOptionOfferValue = newOptionSum.net;
                totalValues.positionOptionOfferGrossValue = newOptionSum.gross;

                totalValues.positionTotalOfferValue = newSum.net + newOptionSum.net;
                totalValues.positionTotalOfferGrossValue = newSum.gross + newOptionSum.gross;
            }

            formikProps.setFieldValue("totalValues", totalValues);
        } else {
            semaphore.current = true;
        }
        // eslint-disable-next-line
    }, [formikProps.values.itemOffers, showOptionSumValues])

    if (itemOffers.length === 0)
        return null;

    return (
        <GeneralInfoEntry biggerLabel label={Tr('items_list')} collapsible defaultCollapsed={false}>
            {
                itemOffers.map((item, index) => (
                    <OfferInput
                        key={item.criterium.identity}
                        id={`itemOffers.${index}`}
                        criterion={item}
                        formikProps={formikProps}
                        priceType={priceType}
                        disabled={disabled}
                    />
                ))
            }
            {
                <GridBlock className={classes.sum} justify="flex-end">
                    <BoldTypography className={classes.sumElem}>{Tr("sum")}: </BoldTypography>
                    <div>
                        {
                            TotalPriceTypeNetFieldVisible(priceType) && <>
                                {
                                    mode === OfferMode.EDIT || !formikProps.values.placingType ?
                                        <Typography
                                            className={classes.sumElem}>{`${Tr('offer_value_net')}: ${formikProps.values.totalValues.positionOfferValue != null ? parseFloat(formikProps.values.totalValues.positionOfferValue).toFixed(2).replace(".", ",") : "_"} PLN`}</Typography>
                                        : <GridBlock>
                                            <Typography className={classes.sumElem}>{`${Tr('offer_value_net')}: `}</Typography>
                                            <TextInput
                                                id="totalValues.positionOfferValue"
                                                formikProps={formikProps}
                                                endAdornment={<Typography>PLN</Typography>}
                                                disabled={disabled}
                                                type={INPUT_TYPE.NUMBER_19}
                                            />
                                        </GridBlock>
                                }
                            </>
                        }
                        {
                            TotalPriceTypeGrossFieldVisible(priceType) && <>
                                {
                                    mode === OfferMode.EDIT || !formikProps.values.placingType ?
                                        <Typography
                                            className={classes.sumElem}>{`${Tr('offer_value_gross')}: ${formikProps.values.totalValues.positionOfferGrossValue != null ? parseFloat(formikProps.values.totalValues.positionOfferGrossValue).toFixed(2).replace(".", ",") : "_"} PLN`}</Typography>
                                        : <GridBlock>
                                            <Typography className={classes.sumElem}>{`${Tr('offer_value_gross')}: `}</Typography>
                                            <TextInput
                                                id="totalValues.positionOfferGrossValue"
                                                disabled={disabled}
                                                endAdornment={<Typography>PLN</Typography>}
                                                formikProps={formikProps}
                                                type={INPUT_TYPE.NUMBER_19}
                                            />
                                        </GridBlock>
                                }
                            </>
                        }
                        {showOptionSumValues && TotalPriceTypeNetFieldVisible(priceType) &&
                            <>
                                {
                                    mode === OfferMode.EDIT || !formikProps.values.placingType ?
                                        <Typography
                                            className={classes.sumElem}>{`${Tr('offer_option_value_net')}: ${formikProps.values.totalValues.positionOptionOfferValue != null ? parseFloat(formikProps.values.totalValues.positionOptionOfferValue).toFixed(2).replace(".", ",") : "_"} PLN`}</Typography>
                                        : <GridBlock>
                                            <Typography className={classes.sumElem}>{`${Tr('offer_option_value_net')}: `}</Typography>
                                            <TextInput
                                                id="totalValues.positionOptionOfferValue"
                                                formikProps={formikProps}
                                                endAdornment={<Typography>PLN</Typography>}
                                                disabled={disabled}
                                                type={INPUT_TYPE.NUMBER_19}
                                            />
                                        </GridBlock>
                                }
                            </>
                        }
                        {showOptionSumValues && TotalPriceTypeGrossFieldVisible(priceType) &&
                        <>
                            {
                                mode === OfferMode.EDIT || !formikProps.values.placingType ?
                                    <Typography
                                        className={classes.sumElem}>{`${Tr('offer_option_value_gross')}: ${formikProps.values.totalValues.positionOptionOfferGrossValue != null ? parseFloat(formikProps.values.totalValues.positionOptionOfferGrossValue).toFixed(2).replace(".", ",") : "_"} PLN`}</Typography>
                                    : <GridBlock>
                                        <Typography className={classes.sumElem}>{`${Tr('offer_option_value_gross')}: `}</Typography>
                                        <TextInput
                                            id="totalValues.positionOptionOfferGrossValue"
                                            formikProps={formikProps}
                                            endAdornment={<Typography>PLN</Typography>}
                                            disabled={disabled}
                                            type={INPUT_TYPE.NUMBER_19}
                                        />
                                    </GridBlock>
                            }
                        </>
                        }
                        {showOptionSumValues && TotalPriceTypeNetFieldVisible(priceType) &&
                        <>
                            <Typography className={classes.sumElem}>{`${Tr('offer_total_value_net')}: ${formikProps.values.totalValues.positionTotalOfferValue != null ? parseFloat(formikProps.values.totalValues.positionTotalOfferValue).toFixed(2).replace(".", ",") : "_"} PLN`}</Typography>
                        </>
                        }
                        {showOptionSumValues && TotalPriceTypeGrossFieldVisible(priceType) &&
                        <>
                            <Typography className={classes.sumElem}>{`${Tr('offer_total_value_gross')}: ${formikProps.values.totalValues.positionTotalOfferGrossValue != null ? parseFloat(formikProps.values.totalValues.positionTotalOfferGrossValue).toFixed(2).replace(".", ",") : "_"} PLN`}</Typography>
                        </>
                        }
                    </div>
                </GridBlock>
            }

        </GeneralInfoEntry>)

}

OfferPositionItems.propTypes = {
    itemOffers: PropTypes.array.isRequired
}

export default OfferPositionItems;